import {AxiosError} from "axios";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {consoleError} from "@pg-mono/logger";

import {store} from "../../../store/store";
import {addNotification} from "../../notifications/state/notifications_slice";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchErrorHandler = (error: AxiosError<any>) => {
    if (error.response?.data?.non_field_errors) {
        error.response.data.non_field_errors.map((value: string) => {
            store.dispatch(addNotification({type: "failure", content: value}));
        });
    }

    consoleError(error.message);

    notifyBugsnagClient(error, error.message);
};
import {AxiosError} from "axios";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {consoleError} from "@pg-mono/logger";

import {store} from "../../../store/store";
import {addNotification} from "../../notifications/state/notifications_slice";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchErrorHandler = (error: AxiosError<any>) => {
    if (error.response?.data?.non_field_errors) {
        error.response.data.non_field_errors.map((value: string) => {
            store.dispatch(addNotification({type: "failure", content: value}));
        });
    }

    consoleError(error.message);

    notifyBugsnagClient(error, error.message);
};
